import { useMemo } from 'react';
import { useSelectedSource } from '../components/source-selector/source-selector';
import { camelToSnake } from '../utils/string';
import { useAuthContext } from './useAuthContext';

export function useSources() {
  const { currentAccount, isSharing, sharedResource } = useAuthContext();
  const { selectedSource, setSelectedSource } = useSelectedSource();

  const sharedSource = sharedResource?.resource?.source;

  const sites = (isSharing && sharedSource?.type === 'SITE' ? [sharedSource] : (currentAccount?.sites ?? [])).map(
    parseEach,
  );

  const gaProperties = (
    isSharing && sharedSource?.type === 'GA_PROPERTY' ? [sharedSource] : (currentAccount?.gaProperties ?? [])
  ).map(parseEach);

  const enabledGaProperties = useMemo(() => {
    return gaProperties.filter((p) => !!p.enabledAt);
  }, [gaProperties]);

  const allSources = useMemo(() => [...sites, ...gaProperties], [sites, gaProperties]);

  const allSelectableSources = useMemo(() => [...sites, ...enabledGaProperties], [sites, enabledGaProperties]);

  const isHydrated = isSharing ? sharedResource !== null : currentAccount !== null;
  const loading = !isHydrated;

  return {
    sites,
    gaProperties,
    enabledGaProperties,
    allSources,
    allSelectableSources,
    isHydrated,
    loading,
    selectedSource,
    setSelectedSource,
  };
}

function parseEach(input) {
  return {
    ...input,
    type: input.__typename ? camelToSnake(input.__typename).toUpperCase() : (input.type ?? null),
    active: input.active ?? null,
    id: input.id,
    installed: input.installed ?? null,
    lastData: input.lastData ?? null,
    name: input.name,
  };
}
